import { useState, useRef, useMemo } from 'react';
import { saveDealer } from '../api/cart';
import { ModalProps } from '../types/recommendationsModal.types';

export function useRecommendationModalState() {
  const [isOpen, setIsOpen] = useState(false);
  const [modalProps, setModalProps] = useState<ModalProps>({
    recommendedItems: [],
    addedMaterialImage: null,
    bagProject: null,
    isInitMaterialAddedToBag: false,
    bannerLabel: '',
    bannerShippingTitle: '',
    bannerShippingSubtitle: null,
    bottomBannerTitle: '',
    bottomBannerSubtitle: '',
    isBrandDailyLimitReached: false,
  });
  const [proposal, setProposal] = useState<Record<string, any> | null>(null);
  const [xHeader, setXHeader] = useState<string | null>(null);
  const closeTimeoutRef = useRef<NodeJS.Timeout | null>(null);
  const [isViewEventTriggered, setIsViewEventTriggered] = useState(false);

  const { ecoTabsLevel, recommendationsIds } = useMemo(() => {
    const addedItems = modalProps.recommendedItems.filter(
      (item) => item.isAddedToCart,
    );
    const recommendationsIds = modalProps.recommendedItems.map(
      (item) => item.id,
    );
    return {
      ecoTabsLevel: addedItems.length,
      recommendationsIds,
    };
  }, [modalProps]);

  const handleCloseClick = () => {
    setIsViewEventTriggered(false);

    if (proposal?.type === 'dealer') {
      saveDealer(null);
    } else if (proposal?.type === 'ask-for-dealer') {
      saveDealer(proposal?.dealerName || null);
    }

    setIsOpen(false);

    setModalProps((prevProps) => ({
      ...prevProps,
      isInitMaterialAddedToBag: false,
      controlRuleId: null,
      addedMaterialImage: !prevProps?.controlRuleId
        ? prevProps?.addedMaterialImage
        : null,
    }));
    setProposal(null);

    if (closeTimeoutRef.current != null) {
      clearTimeout(closeTimeoutRef.current);
      closeTimeoutRef.current = null;
    }
  };

  return {
    isOpen,
    modalProps,
    proposal,
    xHeader,
    isViewEventTriggered,
    closeTimeoutRef,
    ecoTabsLevel,
    recommendationsIds,
    setIsOpen,
    setModalProps,
    setProposal,
    setXHeader,
    setIsViewEventTriggered,
    handleCloseClick,
  };
}
